<template>
  <div v-if="user">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <router-link :to="{name: 'users'}">powrót</router-link>
              </div>
              <div class="col-sm-6 text-right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card" v-if="!editMode">
          <div class="card-header">
            Dane użytkownika
            <div class="card-header-actions">
              <a class="card-header-action" v-if="canEditUser" href @click.prevent="toggleEditMode()">
                Edytuj
              </a>
            </div>
          </div>
          <div class="card-body" v-if="user">
            <div class="row">
              <div class="col-md-5">Login</div>
              <div class="col-md-7">{{ user.username }}</div>
            </div>
            <div class="row">
              <div class="col-md-5">Imię</div>
              <div class="col-md-7">{{ user.firstName }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Nazwisko</div>
              <div class="col-md-7">{{ user.lastName }}</div>
            </div>


            <div class="row">
              <div class="col-md-5">Typ konta</div>
              <div class="col-md-7">{{ $t('users.permissions.' + user.permissions) }}</div>
            </div>
            <div class="row">
              <div class="col-md-5">Status</div>
              <div class="col-md-7">{{ $t('users.status.' + user.active) }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">{{ $t('branchName')}}</div>
              <div class="col-md-7">{{ user.branchName }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">E-mail</div>
              <div class="col-md-7">{{ user.email}}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Utworzony</div>
              <div class="col-md-7">{{ user.created | datetime }}</div>
            </div>

            <div class="row">
              <div class="col-md-5">Zmodyfikowany</div>
              <div class="col-md-7">{{ user.modified | datetime }}</div>
            </div>
          </div>
        </div>
        <div class="card" v-if="editMode">
          <div class="card-header">
            Dane użytkownika
          </div>
          <div class="card-body" v-if="user">
            <form @submit.prevent="updateUser()">
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="firstName">Login</label>
                  <input class="form-control"
                         id="username"
                         v-model="username"
                         v-bind:class="{ 'is-invalid': $v.username.$error }"
                         v-custom-validator="$v.username"
                         type="text"/>
                  <div class="invalid-feedback" v-if="!$v.username.required">
                    {{ $t('error.fieldRequired') }}
                  </div>
                  <div class="invalid-feedback" v-else-if="!$v.username.minLength">
                    {{ $t('error.minLength', [$v.username.$params.minLength.min]) }}
                  </div>
                  <div class="invalid-feedback" v-else-if="!$v.username.maxLength">
                    {{ $t('error.maxLength', [$v.username.$params.maxLength.min]) }}
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="firstName">Imię</label>
                  <input class="form-control"
                         id="firstName"
                         v-model="firstName"
                         v-bind:class="{ 'is-invalid': $v.firstName.$error }"
                         v-custom-validator="$v.firstName"
                         type="text"/>
                  <div class="invalid-feedback" v-if="!$v.firstName.required">
                    {{ $t('error.fieldRequired') }}
                  </div>
                  <div class="invalid-feedback" v-else-if="!$v.firstName.minLength">
                    {{ $t('error.minLength', [$v.firstName.$params.minLength.min]) }}
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="lastName">Nazwisko</label>
                  <input class="form-control"
                         id="lastName"
                         v-bind:class="{ 'is-invalid': $v.lastName.$error }"
                         v-custom-validator="$v.lastName"
                         v-model="lastName"
                         type="text"/>
                  <div class="invalid-feedback" v-if="!$v.lastName.required">
                    {{ $t('error.fieldRequired') }}
                  </div>
                  <div class="invalid-feedback" v-else-if="!$v.lastName.minLength">
                    {{ $t('error.minLength', [$v.lastName.$params.minLength.min]) }}
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="email">E-mail</label>
                  <input class="form-control"
                         id="email"
                         v-bind:class="{ 'is-invalid': $v.email.$error }"
                         v-custom-validator="$v.email"
                         v-model="email"
                         type="text"/>
                  <div class="invalid-feedback" v-if="!$v.email.required">
                    {{ $t('error.fieldRequired') }}
                  </div>
                  <div class="invalid-feedback" v-else-if="!$v.email.email">
                    {{ $t('error.wrongEmail') }}
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="permissions">Typ konta</label>
                  <select class="form-control" id="permissions" v-model="permissions">
                    <option value="20">{{ $t('users.permissions.20') }}</option>
                    <option value="50">{{ $t('users.permissions.50') }}</option>
                    <option value="80" v-has-permissions="81">{{ $t('users.permissions.80') }}</option>
                    <option value="99" v-has-permissions="99">{{ $t('users.permissions.99') }}</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="branchId">{{ $t('branchName') }}</label>
                  <select class="form-control" id="branchId" v-model="branchId">
                    <option value="1">Malinowy Zdrój</option>
                    <option value="2">Malinowy Raj</option>
                    <option value="3">Malinowy Dwór</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="branchId">Status</label>
                  <select class="form-control" id="active" v-model="active">
                    <option value="1">Aktywny</option>
                    <option value="0">Zablokowany</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <button type="submit" class="btn btn-primary">Zapisz dane</button>
                  <button type="button" @click.prevent="toggleEditMode()" class="btn btn-link">
                    Anuluj
                  </button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
      <div class="col-md-6">
        <user-password-change
            v-bind:user-id="user.userId"
            v-bind:component-title="'Zmień hasło użytkownika'">
        </user-password-change>
      </div>
    </div>
  </div>
</template>

<script>
  import users from '@Service/users';
  import UserPasswordChange from '@Component/user-password-change';
  import auth from '@Service/auth';
  import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
  import { toastSuccess, toastError } from '../helpers';

  export default {
    components: {
      UserPasswordChange,
    },
    data() {
      return {
        user: null,
        editMode: false,
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        branchId: '',
        permissions: '',
        active: '',
      };
    },
    validations: {
      username: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      email: {
        email,
      },
      permissions: {
        required,
      },
      branchId: {
        required,
      },
      active: {
        required,
      },
    },
    computed: {
      canEditUser: function () {
        const permissionsLevel = this.user.permissions < 99 ? this.user.permissions + 1 : this.user.permissions;
        return auth.hasPermissions(permissionsLevel);
      },
    },
    methods: {
      setUserData: function (data) {
        this.user = data;
        this.firstName = this.user.firstName;
        this.lastName = this.user.lastName;
        this.email = this.user.email || undefined;
        this.username = this.user.username;
        this.permissions = this.user.permissions;
        this.branchId = this.user.branchId;
        this.active = this.user.active;
        this.$v.$reset();
      },
      getUserData: function () {
        users.getUserDetails(this.$route.params.userId)
          .then(response => {
            const { status, data } = response;
            if (status === 200) {
              this.setUserData(data);
            } else if (status === 204) {
              console.log('Nie ma takiego użytkownika');
            }
          });
      },
      updateUser: function () {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const user = {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            username: this.username,
            branchId: this.branchId,
            permissions: this.permissions,
            active: this.active,
            userId: this.user.userId,
          };
          users.updateUser(user)
            .then(response => {
              const { status, data } = response;
              if (status === 200) {
                this.setUserData(data);
                this.toggleEditMode();
              } else if (status === 204) {
                console.log('Nie ma takiego użytkownika');
              }
              toastSuccess(this.$t('messages.user-update.success'));
            })
            .catch(() => toastError(this.$t('messages.user-update.error')));
        }
      },
      toggleEditMode: function () {
        this.editMode = !this.editMode;
      }
    },
    mounted: function () {
      this.getUserData();
    },
  };
</script>

<style scoped>
</style>
